import { Check, ArrowRight } from 'lucide-react';

const includedFeatures = [
  'Curso Online de Análisis de Datos con Excel (acceso 6 meses)',
  'Guía de funciones y atajos de teclado (Excel y Google Sheets)',
  'Plantillas descargables de Excel',
  '9 clases en vivo sobre datos e IA para RR.HH.',
  'Dashboard automatizado de RR.HH.',
  'Banco de métricas con benchmarks de referencia',
  'Sistema completo de encuesta de clima',
  'Kit de presentaciones para RR.HH. + módulo ChatGPT',
  'Comunidad privada de WhatsApp',
  'Certificado de finalización',
];

export default function PricingTable() {
  return (
    <section id="programa-section" className="py-16 md:py-24 px-6 bg-gradient-to-b from-neutral-50 to-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-black mb-4">
            Conoce el programa de Datos e IA para RR.HH.
          </h2>
          <p className="text-lg text-neutral-600 max-w-2xl mx-auto">
            Aprendé a analizar datos de RR.HH. con IA en dos meses, sin experiencia previa. 9 clases en vivo + todas las herramientas y recursos.
          </p>
        </div>

        {/* Single program card */}
        <div className="rounded-3xl overflow-hidden border-2 border-[#C5075D] shadow-2xl shadow-[#C5075D]/10 bg-white">
          {/* Header */}
          <div className="p-8 md:p-10 text-white bg-gradient-to-br from-[#C5075D] to-[#A00550]">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
              <div>
                <h3 className="text-2xl md:text-3xl font-bold mb-1">Programa de Datos e IA para RR.HH.</h3>
                <p className="text-white/80 text-sm md:text-base">2 meses · 9 clases en vivo · Incluye IA</p>
              </div>
              <div className="text-left md:text-right">
                <span className="text-4xl md:text-5xl font-bold">USD 500</span>
              </div>
            </div>
          </div>

          {/* Features */}
          <div className="p-8 md:p-10">
            <h4 className="font-bold text-neutral-900 text-lg mb-6">Todo lo que incluye:</h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              {includedFeatures.map((feature, idx) => (
                <div key={idx} className="flex items-start gap-3 p-3 rounded-xl bg-[#C5075D]/5 border border-[#C5075D]/10">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#C5075D]/15 flex items-center justify-center mt-0.5">
                    <Check className="w-3.5 h-3.5 text-[#C5075D]" />
                  </div>
                  <span className="text-sm md:text-base text-neutral-800 font-medium">{feature}</span>
                </div>
              ))}
            </div>

            {/* CTA */}
            <div className="mt-10">
              <a
                href="https://aleromanisio.com/programa-datos-ia-rrhh"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-[#C5075D] hover:bg-[#A00550] text-white rounded-xl font-bold text-base transition-all duration-300 hover:shadow-lg hover:scale-[1.02] w-full sm:w-auto"
              >
                Conocer más sobre el programa
                <ArrowRight className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
